import axios from "axios";
import { screenMessage } from "./screenMessage";

/* Staff console + Help API. The web app signs in with an httpOnly cookie; a staff step-up replaces that cookie with
   a 2FA staff session server-side, so nothing is kept in localStorage. */
export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

/* A 401 on this client is for StaffGate. Sign-out sets skipAuthRedirect and uses a different client,
   so this interceptor never redirects that call. */
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.config?.skipAuthRedirect) return Promise.reject(error);
    return Promise.reject(error);
  },
);

/* Admin and staff screens. The server body is never shown. */
export const errMsg = () => screenMessage("admin");

/* One idempotency key per money action: made when the action starts and reused if the same request is retried, so
   a double click or a retry after a network error never pays twice. */
export const newIdemKey = () =>
  (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`).replace(/[^A-Za-z0-9-]/g, "");

export const money = (minor, cur) =>
  cur === "inr" ? `₹${(minor / 100).toLocaleString("en-IN", { minimumFractionDigits: 2 })}` : `US$${(minor / 100).toFixed(2)}`;
